import { render, staticRenderFns } from "./MemberRegistrationForgotPassword.vue?vue&type=template&id=33114f8a"
import script from "./MemberRegistrationForgotPassword.vue?vue&type=script&lang=js"
export * from "./MemberRegistrationForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports